import React, { useEffect, useState } from 'react';

import { CollectionQuery } from 'queries';
import { IContent } from 'types';
import useModal from 'hooks/useModal';
import { toast } from 'react-toastify';
import { DEFAULT_ERROR_MESSAGE } from 'data/message';
import { SelectContentsModal } from 'components/content';
import { CollectionApi } from 'api';

interface Props {
  id: number;
}

function ContentsManage({ id }: Props) {
  const { handleClose } = useModal();
  const { mutate } = CollectionQuery.useUpdate();
  const [contents, setContents] = useState<IContent[] | null>(null);

  const handleSubmit = (contents: IContent[]) => {
    mutate(
      {
        id,
        contents: contents.map((c) => c.id),
        contentSortOrder: contents.map((c, index) => ({
          contentId: c.id,
          sortOrder: index,
        })),
      },
      {
        onSuccess: () => {
          toast.success('저장되었습니다.');
          handleClose();
        },
        onError: () => {
          toast.error(DEFAULT_ERROR_MESSAGE);
        },
      },
    );
  };

  const init = async () => {
    const res = await CollectionApi.get(String(id));
    setContents(res.data.contents);
  };

  useEffect(() => {
    init();
  }, []);

  if (!contents) return null;

  return (
    <SelectContentsModal
      contents={contents}
      onSubmit={handleSubmit}
      pageType="COLLECTION_MODAL"
    />
  );
}

export default ContentsManage;
